import httpClient from '@/services/httpClient'
import { readFileAsync } from '@/utils/file'

import {
  IPatientProfileDataRequest,
  ICountry,
  IEthnicity,
  IGenre,
  ISex,
} from './profile-types'

export const updateProfileInformation = async (
  data: IPatientProfileDataRequest,
  emergencyContactId?: number | null,
): Promise<boolean> => {
  const requestData = {
    nome: data.name?.trim(),
    sexo: data.sex?.trim(),
    cns: data.cns?.trim(),
    flagMaeDesconhecida: data.unknownMother,
    nomeMae: data.nameMother?.trim(),
    idNacionalidade: data.idNacionality?.toString()?.trim(),
    idGenero: data.idGenre?.toString()?.trim(),
    idRacaCor: data.idRaceOrColor?.toString()?.trim(),
    cpf: data.cpf?.trim(),
    rg: data.rg?.toString()?.trim(),
    dataEmissaoRG: data.dateIssueRg?.trim(),
    orgaoEmissorRG: data.issuingBodyRg?.trim(),
    estadoNascimento: data.birthState?.trim(),
    idPais: data.idCountry?.toString()?.trim(),
    nomeSocial: data.socialName?.toString()?.trim(),
    passaporte: data.passport?.trim(),
    dataEmissaoPassaporte: data.dateIssuePassport?.trim(),
    dataVencimentoPassaporte: data.passportExpirationDate?.trim(),
    idUfNascimento: data.idUfBirth,
    municipioNascimento: data.birthCity?.toString()?.trim(),
    celular: data.cellphone?.trim(),
    dataNascimento: data.birthdate?.trim(),
    email: data.email?.trim(),
    cep: data.cep?.trim(),
    cepFormatado: data.formattedCep?.trim(),
    endereco: data.streetName?.trim(),
    numeroLogradouro: data.number?.toString()?.trim(),
    numeroCarteiraConvenio: data.healthInsuranceNumber
      ?.toString()
      ?.trim()
      ?.split(' ')
      ?.join(''),
    complemento: data.complement?.toString()?.trim(),
    bairro: data.neighborhood?.trim(),
    cidade: data.city?.trim(),
    uf: data.state?.trim(),
    contatoEmergencia: {
      idContatoEmergencia: emergencyContactId,
      relacao: data?.relationship?.trim(),
      telefone: data?.emergencyContactCellphone?.trim(),
      nomeCompleto: data?.emergencyContactFullName?.trim(),
    },
  }

  const response = await httpClient.post(
    '/integration/app-paciente/dados-pessoais/alterar-perfil/v2',
    requestData,
  )

  return response?.data?.object
}

export const uploadProfileAvatar = async (avatar: File): Promise<string> => {
  const b64 = (await readFileAsync(avatar)) as string
  const b64String = b64.split('base64,')[1]
  const fileType = avatar.type.split('/')[1]

  const response = await httpClient.post(
    '/integration/app-paciente/dados-pessoais/upload-foto',
    {
      conteudoBase64: b64String,
      nomeExtensao: fileType,
    },
  )

  return response.data.object
}

export const getCountries = async (): Promise<ICountry[]> => {
  const response = await httpClient.get('/user/country')

  return (
    response.data.object?.map(item => {
      return {
        value: item?.key,
        label: item?.value,
      }
    }) || []
  )
}

export const getEthnicities = async (): Promise<IEthnicity[]> => {
  const response = await httpClient.get('/user/race-color')
  return (
    response.data.object?.map(item => {
      return {
        value: item?.key,
        label: item?.value,
      }
    }) || []
  )
}
export const getGenres = async (): Promise<IGenre[]> => {
  const response = await httpClient.get('/user/gender')

  return (
    response.data.object?.map(item => {
      return {
        value: item?.key,
        label: item?.value,
      }
    }) || []
  )
}
export const getSexes = async (): Promise<ISex[]> => {
  const response = await httpClient.get('/user/enums/gender')

  return (
    response.data.object?.map(item => {
      return {
        value: item?.key,
        label: item?.value,
      }
    }) || []
  )
}
